export default __webpack_public_path__ + "static/media/ic-instruction-11.a9fa5e23.svg";